import { SetupWorkflowModel } from '@/model/setup-workflow.model';

export const SETUP_WORKFLOW_FIXTURES: SetupWorkflowModel[] = [
    {
        id: 1,
        templateName: 'Head Office',
        workflowLevel: 1,
        updatedBy: 'K001',
        createDate: '2026/01/01',
        modifiedDate: '2026/01/01',
        status: 1
    },
    {
        id: 2,
        templateName: 'Head Quarter',
        workflowLevel: 3,
        updatedBy: 'K001',
        createDate: '2026/01/01',
        modifiedDate: '2026/01/01',
        status: 2
    }
];

export const TOTAL_LEVEL_WORKFLOW_DROPDOWN_FIXTURES = [
    {id: 1, name: 'ONE', code: 1},
    {id: 2, name: 'TWO', code: 2},
    {id: 3, name: 'THREE', code: 3},
    {id: 4, name: 'FOUR', code: 4},
    {id: 5, name: 'FIVE', code: 5},
]

export const BUTTON_STATUS_DROPDOWN_FIXTURES = [
    {id: 1, name: 'Approve STR', code: 1},
    {id: 2, name: 'Reject STR', code: 3},
    {id: 3, name: 'Rework STR', code: 4},
]

export const EMAIL_TEMPLATE_DROPDOWN_FIXTURES = [
    {id: 1, name: 'Branch Address-1', code: 1},
    {id: 2, name: 'Branch Address-2', code: 2},
    {id: 3, name: 'Branch Address-3', code: 3},
]

export const HOST_RESPOND_DROPDOWN_FIXTURES = [
    {id: 1, name: 'Wfc Respond-1', code: 1},
    {id: 2, name: 'Wfc Respond-2', code: 2},
    {id: 3, name: 'Wfc Respond-3', code: 3},
]
